import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-dropdown_a2ef4406906824f0b4b862c458afe9ed",
  "use": "ic-dropdown_a2ef4406906824f0b4b862c458afe9ed-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 5\" id=\"ic-dropdown_a2ef4406906824f0b4b862c458afe9ed\">\n    <path fill-opacity=\".5\" d=\"M3.575 4.83L.176 1.54A.577.577 0 0 1 0 1.13.562.562 0 0 1 .176.72L.741.173a.599.599 0 0 1 .424-.17.615.615 0 0 1 .423.17L4 2.503 6.41.17A.599.599 0 0 1 6.832 0a.614.614 0 0 1 .423.17l.568.547a.577.577 0 0 1 .176.41.562.562 0 0 1-.176.41L4.423 4.829A.6.6 0 0 1 3.998 5a.615.615 0 0 1-.425-.172l.002.003z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id